'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./Insurance.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Insurance = function (props) {
    var onBtnClick = props.onBtnClick, insuranceLinks = props.insuranceLinks, NextLink = props.NextLink;
    return (React__default['default'].createElement("div", { className: "insurance" },
        React__default['default'].createElement("div", { className: "insurance__title" }, "Asuransi Terbaik 2021"),
        React__default['default'].createElement("div", { className: "insurance__subtitle" },
            React__default['default'].createElement("div", null,
                "Dapatkan ",
                React__default['default'].createElement("span", { className: "label-discount" }, "DISKON 25%"),
                " +",
                ' ',
                React__default['default'].createElement("span", { className: "label-cashback" }, "CASHBACK 10%"),
                ' '),
            React__default['default'].createElement("div", null, "Daftar sekarang untuk penawaran terbatas")),
        insuranceLinks && insuranceLinks.map(function (button) {
            return NextLink ?
                React__default['default'].createElement(NextLink, { href: button.link },
                    React__default['default'].createElement("a", { href: '/#', key: button.text, title: button.text, className: button.gtmClassName, onClick: function () { return onBtnClick(); } }, button.text)) :
                React__default['default'].createElement("a", { key: button.text, title: button.text, href: button.link, className: button.gtmClassName, onClick: function () { return onBtnClick(); } }, button.text);
        })));
};

exports.Insurance = Insurance;
//# sourceMappingURL=Insurance.js.map
